import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {UserDto} from "../../api/models/user-dto";

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  public loggedUserId = new BehaviorSubject(0);

  setLoggedUserId(value: number) {
    this.loggedUserId.next(value);
  }
}
